export const DEFAULT_ADJUSTMENT_LIMIT = 500
export const CASH_ADJUSTMENT_LIMIT_KEY = "cash_adjustment_limit"
export const MAX_MOVING_AVERAGE_WINDOW = 200

export const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN" })

export const parseToDate = (value) => {
  if (!value) return null
  const isPlainDate = /^\d{4}-\d{2}-\d{2}$/.test(String(value))
  return isPlainDate ? new Date(`${value}T00:00:00`) : new Date(value)
}

export const formatDateLabel = (value) => {
  const dt = parseToDate(value)
  if (!dt) return ""

  return new Intl.DateTimeFormat("es-MX", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(dt)
}

export const getStoredAdjustmentLimit = () => {
  if (typeof window === "undefined") {
    return DEFAULT_ADJUSTMENT_LIMIT
  }

  const storedLimit = Number(window.localStorage.getItem(CASH_ADJUSTMENT_LIMIT_KEY))
  return Number.isFinite(storedLimit) && storedLimit > 0 ? storedLimit : DEFAULT_ADJUSTMENT_LIMIT
}

export const setStoredAdjustmentLimit = (limit) => {
  const cleanLimit = Number(limit)
  if (!Number.isFinite(cleanLimit) || cleanLimit <= 0) return DEFAULT_ADJUSTMENT_LIMIT
  if (typeof window === "undefined") return cleanLimit

  window.localStorage.setItem(CASH_ADJUSTMENT_LIMIT_KEY, String(cleanLimit))
  return cleanLimit
}

export const getMovementDate = (movement) => movement?.cash_operation_day?.operation_date || movement?.created_at

export const getSignedAdjustmentAmount = (movement) => {
  const amount = Number(movement?.cash || 0)

  if (amount < 0) {
    return amount
  }

  if (movement?.source_account_type && !movement?.destination_account_type) {
    return amount * -1
  }

  return amount
}

export const getAverage = (values) => {
  if (!values.length) return 0
  return values.reduce((total, value) => total + value, 0) / values.length
}

export const getStandardDeviation = (values, average) => {
  if (!values.length) return 0
  const variance = values.reduce((total, value) => total + Math.pow(value - average, 2), 0) / values.length
  return Math.sqrt(variance)
}

export const buildAdjustmentRows = (movements) =>
  (movements || [])
    .filter((movement) => movement?.movement_type === "adjustment")
    .map((movement) => ({
      date: getMovementDate(movement),
      amount: getSignedAdjustmentAmount(movement),
    }))
    .filter((item) => item.date)
    .sort((a, b) => parseToDate(a.date) - parseToDate(b.date))

export const buildWithdrawalRows = (movements) =>
  (movements || [])
    .filter((movement) => movement?.movement_type === "withdraw")
    .map((movement) => ({
      date: getMovementDate(movement),
      amount: Number(movement?.cash || 0),
    }))
    .filter((item) => item.date)
    .sort((a, b) => parseToDate(a.date) - parseToDate(b.date))

export const getAdjustmentBalance = (movements) =>
  buildAdjustmentRows(movements).reduce((total, item) => total + item.amount, 0)

export const getAdjustmentLimitStatus = (movements, nextAmount, limit) => {
  const currentBalance = getAdjustmentBalance(movements)
  const nextBalance = currentBalance + Number(nextAmount || 0)
  const cleanLimit = Number(limit || DEFAULT_ADJUSTMENT_LIMIT)

  return {
    currentBalance,
    nextBalance,
    isOutOfLimit: Math.abs(nextBalance) > cleanLimit,
  }
}
